import { ModelSingleParameter } from "../redux/App.store";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

interface Props {
  parameters: Array<ModelSingleParameter>;
}

const ModelParametersTable = ({ parameters }: Props) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Parâmetro </TableCell>
            <TableCell align="right">Valor</TableCell>
            <TableCell align="right">Desvio padrão</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {parameters.map((par) => (
            <TableRow key={par.repr}>
              <TableCell component="th" scope="row">
                {par.repr}
              </TableCell>
              <TableCell align="right">{par.value.toFixed(5)}</TableCell>
              <TableCell align="right">{par.stddev.toFixed(5)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ModelParametersTable;
